import { z } from "zod";

export const mailSearch = z.object({
  inbox: z.string().optional(),
  view: z.enum(["inbox", "starred", "sent", "all", "trash"]).catch("inbox"),
  label: z.coerce.number().optional(),
  thread: z.string().optional(),
  q: z.string().optional(),
});

export type MailSearch = z.infer<typeof mailSearch>;
export type MailView = MailSearch["view"];

export interface MailRouteSearch {
  inbox?: string;
  view?: MailView;
  label?: number;
  thread?: string;
  q?: string;
}

export function parseMailSearch(
  search: Record<string, unknown>,
): MailRouteSearch {
  const parsed = mailSearch.parse(search);
  const result: MailRouteSearch = { view: parsed.view };
  if (parsed.inbox) result.inbox = parsed.inbox;
  if (parsed.label != null && !Number.isNaN(parsed.label)) {
    result.label = parsed.label;
  }
  if (parsed.thread) result.thread = parsed.thread;
  if (parsed.q) result.q = parsed.q;
  return result;
}
